import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, of} from 'rxjs';
import { environment } from 'src/environments/environment';
import {GeoInfo} from '../models/geo-info';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GeoInfoService {

  constructor(private httpClient: HttpClient) { }

  public getGeoInfo(): Observable<GeoInfo> {
    return this.httpClient.get(`${environment.apiUrl}geotest`)
      .pipe(
        catchError(() => of(null))
      ) as Observable<GeoInfo>;
  }
}
